import { render, staticRenderFns } from "./corporateLoginPage.vue?vue&type=template&id=89cf943a&scoped=true&"
import script from "./corporateLoginPage.vue?vue&type=script&lang=js&"
export * from "./corporateLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./corporateLoginPage.vue?vue&type=style&index=0&id=89cf943a&prod&lang=scss&"
import style1 from "./corporateLoginPage.vue?vue&type=style&index=1&id=89cf943a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cf943a",
  null
  
)

export default component.exports